export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_DEMO = process.env.REACT_APP_IS_DEMO ? JSON.parse(process.env.REACT_APP_IS_DEMO) : false;
export const ENABLE_DEBUG_MODE = process.env.REACT_APP_ENABLE_DEBUG_MODE
  ? JSON.parse(process.env.REACT_APP_ENABLE_DEBUG_MODE)
  : false;
